<template>
  <div class="card">
    <div class="card-header"><h1 style="font-size: 24px;">Cart</h1></div>
    <div class="card-body">
      <h2 style="font-size: 20px;">Review Your Order</h2>
      <b-row>
        <b-col>
          <b-alert variant="danger" dismissible :show="(!this.hasProduct) && checkout">
            Cannot make an empty order.
          </b-alert>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8">
          <div class="card">
          <div class="card-header">
          <b-row>
            <b-col>Product Line Item</b-col>
            <b-col>Record Subject Name or Data Record Year</b-col>
            <b-col>Quantity Ordered</b-col>
            <b-col>Product Fee</b-col>
            <b-col>Actions</b-col>
          </b-row>
          </div>
          <div class="card-body" v-for="(orderProduct, index) in order.orderProducts" :key="index">
              <b-row>
                <b-col>
                  {{orderProduct.product?.name}}
                </b-col>
                <b-col>
                  {{orderProduct.subjectNameOrYear}}
                </b-col>
                <b-col v-if="limitedService.isLimited(orderProduct.product?.category, orderProduct.product?.code)">
                  <BaseTextInput v-model="orderProduct.quantity"
                                 label="Quantity To Order"
                                 setId="quantityToOrder"
                                 slug="quantity"
                                 :v="$v.order.orderProducts.$each[index].quantity"
                                 type="number"
                                 :min="0" :max="1"
                                 @input="recalculateFee(orderProduct.id, orderProduct.quantity)"
                  ></BaseTextInput>
                </b-col>
                <b-col v-else>
                  <BaseTextInput v-model="orderProduct.quantity"
                                 :label="orderProduct.product?.code !== 'AMENDMENT_BIRTH_CERTIFICATE' ?
                                          'Quantity To Order' : 'Quantity of birth certificate(s) to order'"
                                 slug="quantity"
                                 setId="quantityToOrder"
                                 :v="$v.order.orderProducts.$each[index].quantity"
                                 type="number"
                                 :min="0"
                                 @input="recalculateFee(orderProduct.id, orderProduct.quantity)"
                  ></BaseTextInput>
                </b-col>
                <b-col>
                  ${{orderProduct.fee?.amount}}
                </b-col>
                <b-col>
                  <b-button @click="removeProduct(orderProduct.id)" variant="danger">
                    <b-icon icon="trash" aria-hidden="true"/>Delete
                  </b-button>
                </b-col>
              </b-row>
          </div>
            <b-row>
              <b-col cols="12" class="mt-5">
                <b-card>
                  <b-row class="mt-3">
                    <b-col>
                      <b-form-checkbox
                          size="md"
                          v-model="order.expedited"
                          class="font-weight-bold"
                          @change="updateExpedite()">
                        Expedite Order
                      </b-form-checkbox>
                    </b-col>
                    <b-col cols="8">
                      We will process your request in the order it is received. If you want us to handle your order ahead of other requests, select expedited processing.
                      Expedited processing does not include express delivery (rush shipping). Check our <a href="https://www.health.state.mn.us/people/vitalrecords/index.html" class="mdh-green-link" target="_blank">processing times</a> to estimate how long it will take to get your order.
                      <br><br>
                      Expedite moves your order ahead of others so that your order is processed faster. Expedite does not ship or mail your order faster.
                      An expedite fee will be charged for each product included in the order. Order products separately if you do not need all products expedited.
                      <br><br>
                      Expediting your order will move it ahead of all non-expedited orders for processing.
                    </b-col>
                  </b-row>

                  <b-card class="border-danger mt-3" v-if="hasFee">
                    <b-row>
                      <b-col>
                        <b-icon icon="exclamation-circle-fill" variant="danger"></b-icon>
                        A service fee will be charged for all orders at time of payment.
                      </b-col>
                    </b-row>
                  </b-card>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="4">
          <div class="card">
            <div class="card-header">Total</div>
            <div class="card-body">
              <b-row>
                <b-col>
                  Product Total
                </b-col>
                <b-col offset="4">
                  ${{totalProductFee(order)}}
                </b-col>
              </b-row>
              <b-row v-for="(fee, index) in order.nonProductFees" :key="index">
                <b-col>
                  {{fee?.feeType?.description}}
                </b-col>
                <b-col offset="4">
                  ${{fee.amount}}
                </b-col>
              </b-row>
              <b-row class="border-top mt-2 pt-2 font-weight-bold">
                <b-col offset="4">
                  Total:
                </b-col>
                <b-col>
                  ${{totalFee(order)}}
                </b-col>
              </b-row>
              <b-card class="border-danger mt-3">
                <b-row>
                  <b-col>
                    <b-icon icon="exclamation-circle-fill" variant="danger"></b-icon>
                    A service fee will be charged for all orders at time of payment.
                  </b-col>
                </b-row>
              </b-card>
              <b-row class="mt-3">
                <b-col align-h="start">
                  <b-button type="button" variant="primary" @click="validate">
                    Check Out
                  </b-button>
                </b-col>
                <b-col align-h="end">
                  <router-link :to="{name: 'product-select'}">
                    <b-button type="button" variant="primary" class="m-0">
                      Add Another Product
                    </b-button>
                  </router-link>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>

</template>
<script>


import axiosRetry from 'axios-retry'
import axios from "axios"
import LocalStorageService from "@/common/LocalStorageService";
import BaseTextInput from "@/components/templates/input/BaseTextInput.vue";
import {minValue, required} from "vuelidate/lib/validators";
import {totalService} from "@/mixins/totalService";
import {limitedService} from "@/mixins/limitedService";

axiosRetry(axios, { retries: 3,
  retryDelay: axiosRetry.exponentialDelay  });

const localStorageService = LocalStorageService.getService();


export default {
  components: {BaseTextInput},
  data: () => {
    return {
      order: {},
      checkout: false,
    }
  },
  mixins: [
    totalService,
    limitedService
  ],
  mounted() {
    this.loadOrder()
  },
  methods: {
    updateExpedite(){
      const payload = {
        id: localStorageService.getOrderNumber(),
        expedited: this.order.expedited
      }
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/order/expedite`, payload)
              .then(response=>{
                this.loadOrder()
              })
    },
    loadOrder(){
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/order/orderSummary/${localStorageService.getOrderNumber()}`)
          .then(response=>{
            this.order = response.data
            localStorageService.setCartItems(this.order.orderProducts.length)
            this.$emit('cart-update')
          })
    },
    recalculateFee(product, quantity) {
      let payload = {
        id: product,
        quantity: quantity
      }
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/order/quantity`, payload)
          .then(response=>{
            if (quantity === "0") {
              const idx = this.order.orderProducts.findIndex(p => p.id === product)
              this.order.orderProducts[idx].fee = { amount : 0 }
            } else {
              const idx = this.order.orderProducts.findIndex(p => p.id === product)
              this.order.orderProducts[idx].fee = response.data
            }
          })
      this.updateExpedite()
    },
    removeProduct(product) {
      axios.delete(`${process.env.VUE_APP_API_BASE_URL}/order/${product}`)
          .then(response=>{
            const idx = this.order.orderProducts.findIndex(p => p.id === product)
            this.order.orderProducts.splice(idx, 1)
          })
    },
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid
      if (isValid) {
        this.$router.push({name: 'checkout'})
      } else {
        this.checkout = true
      }
      return isValid
    },
  },
  computed: {
    limitedService() {
      return limitedService
    },
    hasFee() {
      let fee = this.totalFee(this.order)
      return fee > 0
    },
    hasProduct() {
      if (this.order && this.order?.orderProducts) {
        let nonzero = this.order.orderProducts
            .some((product) => product.quantity > 0.00)
        return this.order.orderProducts.length > 0 && nonzero
      }
      return false
    }
  },
  validations() {
    return {
      order: {
        required: false,
        orderProducts: {
          required: false,
          hasProduct: {
            reqProduct() {
              return this.hasProduct;
            }
          },
          $each: {
            quantity: { required, minValue: minValue(0), maxValue: function(value, parent) {
                return (!limitedService.isLimited(parent?.product?.category, parent?.product?.code) || value <= 1);
                }
              },
          }
        }
      },
      form: [ 'order' ]
    }
  },
  created() {
    document.title = "Cart - Online Storefront"
  },
}
</script>

<style>
h5 {
  font-weight: bold;
  font-family: inherit;
}
</style>
